import { registerCapability } from '../../platform/capability-registry';
import { MaasTaskTemplateBlock } from './MaasTaskTemplateBlock';
import type { MaasTaskTemplateBlockOptions } from './blockTypes';
import { MAAS_TASK_TEMPLATE_ACTION_KEY_LIST, MAAS_TASK_TEMPLATE_FIELD_KEY_LIST } from './fieldKeys';

registerCapability<MaasTaskTemplateBlockOptions>({
  key: 'maas-task-template',
  fields: [...MAAS_TASK_TEMPLATE_FIELD_KEY_LIST],
  actions: [...MAAS_TASK_TEMPLATE_ACTION_KEY_LIST],
  component: MaasTaskTemplateBlock,
  defaultPaths: () => ({ list: 'taskTemplate' }),
});
